import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { deleteStorySession, getStorySessions } from '@/services/storytime.service';
import type { StoryTimeSessionHistoryResponse } from '@/types/storytime.types';

export const storyTimeKeys = {
  all: ['storytime'] as const,
  sessions: (page: number, limit: number) => ['storytime', 'sessions', page, limit] as const,
};

export const useStoryTimeSessions = (page = 1, limit = 20) => {
  return useQuery<StoryTimeSessionHistoryResponse>({
    queryKey: storyTimeKeys.sessions(page, limit),
    queryFn: () => getStorySessions({ page, limit }),
    staleTime: 30_000,
    gcTime: 5 * 60 * 1000,
  });
};

export const useDeleteStorySession = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (sessionId: string) => deleteStorySession(sessionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: storyTimeKeys.all });
    },
  });
};
